import { Divider, Grid, Skeleton, Stack } from '@/primitives';

export const LoadingTable = () => {
  return (
    <Grid container direction="column" spacing={2}>
      <Grid>
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
          spacing={2}
          width="100%"
        >
          <Skeleton variant="rounded" height={30} width="25%" />
          <Skeleton variant="rounded" height={30} width="25%" />
          <Skeleton variant="rounded" height={30} width="25%" />
          <Skeleton variant="rounded" height={30} width="25%" />
        </Stack>
      </Grid>
      <Divider orientation="horizontal" flexItem />
      <Grid>
        <Stack
          width="100%"
          direction="column"
          spacing={2}
          divider={<Divider orientation="horizontal" flexItem />}
        >
          <Skeleton variant="rounded" height={50} />
          <Skeleton variant="rounded" height={50} />
          <Skeleton variant="rounded" height={50} />
          <Skeleton variant="rounded" height={50} />
        </Stack>
      </Grid>
    </Grid>
  );
};
